import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { INTRO_DELAY } from "@/lib/intro";

const IntroSplash = () => {
    const [show, setShow] = useState(INTRO_DELAY > 0);

    useEffect(() => {
        if (!show) return;
        const t = setTimeout(() => setShow(false), 2600);
        return () => clearTimeout(t);
    }, [show]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="intro-splash"
                    className="fixed inset-0 z-[200] flex items-center justify-center bg-mist"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.5, ease: "easeOut" } }}
                >
                    <motion.img
                        src="/logo-full.png"
                        alt="CS Studio — Web Design"
                        className="w-56 sm:w-72"
                        initial={{ opacity: 0, scale: 0.92, x: "0vw", y: "0vh" }}
                        animate={{
                            opacity: [0, 1, 1, 1, 0],
                            scale: [0.92, 1, 1, 0.09, 0.09],
                            x: ["0vw", "0vw", "0vw", "-36vw", "-36vw"],
                            y: ["0vh", "0vh", "0vh", "-42vh", "-42vh"],
                        }}
                        transition={{
                            duration: 2.2,
                            times: [0, 0.22, 0.55, 0.85, 1],
                            ease: "easeInOut",
                        }}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default IntroSplash;
